import { render, staticRenderFns } from "./DeliveryScreen.vue?vue&type=template&id=56540303&scoped=true&"
import script from "./DeliveryScreen.vue?vue&type=script&lang=js&"
export * from "./DeliveryScreen.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryScreen.vue?vue&type=style&index=0&id=56540303&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56540303",
  null
  
)

export default component.exports